module.exports = __webpack_public_path__ + "img/arrows-angle-expand.ad6db05f.svg";